import { useMemo } from "react";
import { useSelector } from "../../../../app/helpers";
import { RootState } from "../../../../app/rootReducer";
import { useRemoteFetchUserLocationAdminLocations } from "./useRemoteFetchUserLocationAdminLocations";

/** Location inventory ids the current user administers (location-admin role only). */
export function useLocationAdminLocationIds(): number[] {
  const { isLocationAdmin } = useSelector((state: RootState) => state.login.userRoles);
  const { data } = useRemoteFetchUserLocationAdminLocations(isLocationAdmin);

  return useMemo(() => data?.map(row => row.locationInventoryId) ?? [], [data]);
}
